import { Avatar } from '@latitude/avatar';
import { Icon } from '@latitude/icons';
import { Text } from '@latitude/text';
import { Tooltip } from '@latitude/tooltip';
import cn from 'classnames';

export const QUESTION_NOTE_TOOLTIP =
  'Anchorage Digital has added specific guidance for this question to help you provide the most relevant information.';

export const QUESTION_NOTE_AVATAR_LABEL = 'Guidance from Anchorage Digital';

type Props = {
  note: string;
  className?: string;
};

export const QuestionNote = ({ note, className }: Props) => (
  <div
    className={cn('flex items-start gap-spacing-sys-spacing-4', className)}
    data-testid="question-note"
  >
    <Tooltip text={QUESTION_NOTE_TOOLTIP} side="bottom" align="start">
      <Avatar
        type="icon"
        size="tiny"
        variant="strong"
        icon={<Icon name="notification-message" />}
        className="shrink-0 text-color-comp-avatar-strong-on-container"
        // The avatar is the focusable tooltip trigger, so it needs its own
        // name: Radix describes the wrapper, not this element.
        role="img"
        aria-label={QUESTION_NOTE_AVATAR_LABEL}
        tabIndex={0}
      />
    </Tooltip>
    <div className="min-w-0 flex-1 rounded-bl-radius-sys-radius-8 rounded-br-radius-sys-radius-8 rounded-tr-radius-sys-radius-8 border-border-sys-border-2 border-color-ref-ui-divider-strong p-spacing-sys-spacing-8">
      <Text
        color="muted"
        variant="captionRegular"
        className="whitespace-pre-line"
      >
        {note}
      </Text>
    </div>
  </div>
);
